module.exports = "/_next/static/images/success-8e738ccc68a807b0ee156debdc96cf7b.svg";